import { Mark } from '@tiptap/core'

const TextGradientColor = Mark.create({
  name: 'textgradientcolor',

  addOptions () {
    return {
      backgroundImage: ['red'],
      raw: [],
      direction: 90
    }
  },

  addAttributes () {
    return {
      raw: {
        default: [],
        parseHTML: element => {
          const raw = element.getAttribute('dataraw') || element.getAttribute('dataRaw') || '[]'
          try {
            return JSON.parse(raw)
          } catch (e) {
            return raw
          }
        },
        renderHTML: attrs => ({
          dataRaw: Array.isArray(attrs.raw) ? JSON.stringify(attrs.raw) : attrs.raw
        })
      },
      backgroundImage: {
        default: 'red',
        parseHTML: element => {
          return element.style.backgroundImage || element.getAttribute('data-background-image') || 'red'
        },
        renderHTML: attrs => ({
          style: `background-image:${attrs.backgroundImage}`
        })
      },
      direction: {
        default: 90,
        parseHTML: element => {
          const val = element.getAttribute('dataDirection') || element.getAttribute('data-direction')
          const num = Number(val)
          return Number.isFinite(num) ? num : 90
        },
        renderHTML: attrs => ({
          dataDirection: attrs.direction
        })
      }
    }
  },

  parseHTML () {
    return [
      {
        tag: 'gradient-span'
      }
    ]
  },

  renderHTML ({ HTMLAttributes }) {
    const attrs = {
      ...HTMLAttributes
    }

    return ['gradient-span', attrs, 0]
  },

  addCommands () {
    return {
      textgradientcolor: attrs => ({ commands }) => {
        if (!attrs) {
          return commands.unsetMark(this.name)
        }

        const gradientArray = Array.isArray(attrs.backgroundGradient) ? attrs.backgroundGradient : []
        const direction = typeof attrs.gradientDirection === 'number' ? attrs.gradientDirection : 90

        const values = gradientArray.map(gradient => {
          return `${gradient.color} ${gradient.position}%`
        })
        const backgroundImage = `linear-gradient(${direction}deg,${values})`

        const payload = {
          backgroundImage,
          raw: gradientArray,
          direction
        }

        return commands.setMark(this.name, payload)
      }
    }
  }
})

export default TextGradientColor
